var _defs, _rect, _rect2, _text, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "\\u0423\\u0447\\u0413\\u0440\\u0430\\u0434 \\u2014 \\u0423\\u0413 \\u043D\\u0430 \\u043E\\u0442\\u043A\\u0440\\u044B\\u0442\\u043E\\u0439 \\u043A\\u043D\\u0438\\u0433\\u0435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ugrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FDBA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA580C"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 88,
    height: 88,
    rx: 22,
    fill: "#0F172A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 85,
    height: 85,
    rx: 20.5,
    fill: "none",
    stroke: "#334155",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 47,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "bold",
    fontSize: 28,
    fill: "url(#ugrad)"
  }, "\u0423\u0413")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 62 C29 55 42 55 48 60.5 C54 55 67 55 78 62 L78 72 C67 65 54 65 48 70.5 C42 65 29 65 18 72 Z",
    fill: "url(#ugrad)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60.5 L48 70.5",
    stroke: "#0F172A",
    strokeWidth: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.64efd183d518d7b47bb6b33cb0e7e51f.svg";
export { ForwardRef as ReactComponent };